import React from "react";
import "../styles/tertiaryprojthumbnail.css";
import { Link } from "react-router-dom";

const TertiaryProjThumbnail = ({ item }) => {
  return (
    <div className="tertiary-card">
      <Link className="" key={item.id} to={`/Projects/${item.id}`}>
        {/* <div className="card-role">Next.js · TypeScript · API</div> */}
        <div className="card-title">{item.text}</div>
        <div className="card-desc">{item.subtext}</div>
        <div className="card-tags">
          {item.techstack.map((skill, i) => (
            <span key={i} className="tag">
              {skill}
            </span>
          ))}
        </div>
      </Link>
    </div>
  );
};

export default TertiaryProjThumbnail;
